import Resource from './resource';
import defaultResolver from './default-resolver';

import pageConnectionQuery from './graphql/pageConnectionQuery.graphql';

class PageResource extends Resource {
  fetchAll(first = 20) {
    return this.graphQLClient
      .send(pageConnectionQuery, { first })
      .then(defaultResolver('pages'));
  }
}

export default PageResource;
